import React, { Component } from 'react'
import { connect } from 'react-redux'
import InputRange from 'react-input-range'
import '../../common/css/react-range.css'
import { GET_LOOKUP_GROUPS, GET_GROUP_ITEMS } from '../../requests'
import { MASK } from '../Wizard2/validate.js'
import { DateInput } from 'components/Wizard2/fieldComponents/Form'
import TextEditor from './TextEditor'
import MetaEditor from './MetaEditor'
import ConstraintsEditor from './ConstraintsEditor'
import SelectOptionConstrainer from './SelectOptionConstrainer'
import Portal from 'components/Portal/Portal'
import { ConfirmDialog } from '../Modal/Modal'
import { stateOptions } from '../Wizard2/selectOptions'
import shortid from 'shortid'
import { noop } from 'utilities'
import MultiComplete from '../Wizard2/fieldComponents/MultiComplete'
import LockIcon from '@tecuity/sos-icons/react/lock'
import store from '../../store'
import CustomBusinessRulesEditor from './CustomBusinessRulesEditor'
import { setOptionsCache, setOptionsCacheById } from './DesignerActions'
import RegulatedWordsSelector from './RegulatedWordsSelector'

export class Attribute extends Component {
  constructor() {
    super()
    this.state = { focused: false, confirmOpen: false, confirmed: false }
    this.id = shortid.generate()
  }
  htmlId = shortid.generate()
  handleTextChange = e => {
    let value = e.target.value
    if (this.props.maxLength) {
      value = value.slice(0, this.props.maxLength)
    }
    this.props.handleChange(this.props.name, value, this.props.additionalName)
  }
  handleNumberChange = e => {
    this.props.handleChange(
      this.props.name,
      MASK.onlyNumbers(e.target.value),
      this.props.additionalName
    )
  }
  handleFloatChange = e => {
    this.props.handleChange(
      this.props.name,
      MASK.onlyNumbers(e.target.value, { allowDecimal: true }),
      this.props.additionalName
    )
  }
  handleRangeChange = e => {
    if (/%/.test(this.props.value)) {
      e += '%'
    }
    this.props.handleChange(this.props.name, e, this.props.additionalName)
  }
  handleCheckChange = e => {
    this.props.handleChange(this.props.name, e.target.checked, this.props.additionalName)
  }
  handleSelectChange = e => {
    this.props.handleChange(this.props.name, e.target.value, this.props.additionalName)
  }
  handleGenericChange = (name, value) => {
    this.props.handleChange(name, value, this.props.additionalName)
  }
  fireButtonAction = () => {
    store.dispatch({
      type: this.props.action,
      ...this.props.actionPayload
    })
    if (this.props.onActionFired) {
      this.props.onActionFired()
    }
  }
  sanitizeRangeValue = value => {
    value = value.toString()
    return parseInt(value.replace('%', ''), 10)
  }
  handleFocus = () => {
    this.setState({ focused: true, unFocused: false })
  }
  handleBlur = () => {
    this.setState({ unFocused: true })
  }
  handleTransition = () => {
    this.setState({ focused: false })
  }
  render() {
    let focusEvents = { onFocus: this.handleFocus, onBlur: this.handleBlur }
    const disabled = this.props.disabled || this.props.isLogicControlled
    return (
      <div
        className={
          'dummy-field attribute ' +
          (this.props.className ? this.props.className : '') +
          (this.props.isLogicControlled ? 'logic-controlled' : '')
        }
        onClick={this.props.onClick}
        style={this.props.padding === false ? { paddingLeft: '0px', paddingRight: '0px' } : null}
      >
        {this.props.isLogicControlled ? (
          <React.Fragment>
            <span className="round-icon-wrapper">
              <LockIcon />
            </span>
            <span className="logic-tip">This attribute is being controlled by the logic editor.</span>
          </React.Fragment>
        ) : null}
        {this.props.type !== 'checkbox' &&
        this.props.type !== 'button' &&
        this.props.label !== '' &&
        this.props.type !== 'required' &&
        this.props.type !== 'textEditor' &&
        this.props.label ? (
          <label id={this.htmlId} className={'field-label '}>
            <span className={'label-text ' + (this.props.required ? 'required' : '')}>
              {this.props.label}
            </span>
            {this.props.tip ? (
              <span aria-hidden="true" className="tip" title={this.props.tip}>
                i
              </span>
            ) : null}
          </label>
        ) : null}
        {this.props.description !== '' && this.props.description ? (
          <p className="description">{this.props.description}</p>
        ) : null}
        {this.props.type === 'text' && (
          <div>
          <input
            aria-labelledby={this.htmlId}
            aria-describedby={`info${this.htmlId}`}
            type="text"
            value={this.props.value}
            onChange={this.handleTextChange}
            disabled={disabled}
          />
          {this.props.tip && <p id={`info${this.htmlId}`} className="visually-hidden"> {this.props.tip} </p> }
          </div>
        )}
        {this.props.type === 'number' && (
          <input type="text" value={this.props.value} onChange={this.handleNumberChange} />
        )}
        {this.props.type === 'float' && (
          <input type="text" value={this.props.value} onChange={this.handleFloatChange} />
        )}
        {this.props.type === 'date' && (
          <DateInput
            value={this.props.value}
            onChange={date => {
              this.handleGenericChange(this.props.name, date)
            }}
          />
        )}
        {this.props.type === 'textarea' ? (
          <div className="block-wrapper">
            <textarea
              aria-labelledby={this.htmlId}
              aria-describedby={`info${this.htmlId}`}
              rows={this.props.rows}
              cols={this.props.cols}
              onChange={this.handleTextChange}
              disabled={disabled}
              {...focusEvents}
              value={this.props.value ? this.props.value : ''}
            ></textarea>
            {this.props.tip && <p id={`info${this.htmlId}`} className="visually-hidden"> {this.props.tip} </p> }
            {this.props.markdown && this.state.focused ? (
              <span
                className={
                  'markdown-instructions animated fast-animation ' +
                  (!this.state.unFocused ? 'fadeIn' : 'fadeOut')
                }
                onTransitionEnd={this.handleTransition}
              >
                _<i>italic</i>_ &nbsp; **<b>bold</b>** &nbsp; [Link Text](URL) &nbsp;{' '}
                <a href="http://commonmark.org/help/" target="_blank">
                  ...More
                </a>
              </span>
            ) : null}
          </div>
        ) : null}
        {this.props.type === 'select' ? (
          <div>
          <select
            aria-labelledby={this.htmlId}
            aria-describedby={`info${this.htmlId}`}
            onChange={this.handleSelectChange}
            disabled={disabled}
            value={this.props.value}>
            {this.props.options.map((option, i) => {
              return (
                <option value={option.value} key={i}>
                  {option.label}
                </option>
              )
            })}
          </select>
          {this.props.tip && <p id={`info${this.htmlId}`} className="visually-hidden"> {this.props.tip} </p> }
        </div>
        ) : null}
        {this.props.type === 'stateSelect' && (
          <Attribute {...this.props} label="" type="select" options={stateOptions} />
        )}
        {this.props.type === 'serverOptions' ? (
          <ServerAttributeSelect
            optionsSrc={this.props.optionsSrc}
            subOptionsSrc={this.props.subOptionsSrc}
            controlType={this.props.controlType}
            options={this.props.options}
            required={this.props.required}
            value={this.props.value}
            placeholder={this.props.placeholder}
            hideDefaultValue={this.props.hideDefaultValue}
            isOverridingSubOptionsSrc={this.props.isOverridingSubOptionsSrc}
            isOverridingOptionsSrc={this.props.isOverridingOptionsSrc}
            isInRepeater={this.props.isInRepeater}
            defaultValue={this.props.defaultValue}
            onChange={this.handleGenericChange}
          />
        ) : null}
        {this.props.type === 'genericServerOptions' ? (
          <GenericServerAttributeSelect {...this.props} onChange={this.handleGenericChange} />
        ) : null}
        {this.props.type === 'checkbox' ? (
          <div className="checkbox-wrapper">
            <input
              aria-describedby={`info${this.htmlId}`}
              id={this.id}
              name={this.id}
              type="checkbox"
              checked={this.props.value === undefined ? false : this.props.value}
              className="attr-checkbox"
              onChange={this.handleCheckChange}
              disabled={disabled}
            />
            <label className="checkbox-box" htmlFor={this.id} />
            <label htmlFor={this.id} className={'field-label check-label checkbox-label'}>
              <span className="label-text">{this.props.label}</span>
              {this.props.tip ? (
                <span
                aria-hidden="true"
                className="tip" title={this.props.tip}>
                  i
                </span>
              ) : null}
            </label>
            {this.props.tip && <p id={`info${this.htmlId}`} className="visually-hidden"> {this.props.tip} </p> }
          </div>
        ) : null}
        {this.props.type === 'required' ? (
          <RequiredAttribute
            hasBusinessRules={this.props.hasBusinessRules}
            checked={this.props.value}
            label={this.props.label}
            onChange={this.handleGenericChange}
          />
        ) : null}
        {this.props.type === 'range' ? (
          <InputRange
            aria-labelledby={this.htmlId}
            minValue={this.props.minValue}
            maxValue={this.props.maxValue}
            step={this.props.step}
            value={this.sanitizeRangeValue(this.props.value)}
            onChange={this.handleRangeChange}
          />
        ) : null}
        {this.props.type === 'button' ? (
          <button
            className={'attribute-button ' + this.props.buttonClass}
            onClick={
              this.props.requiresConfirm
                ? () => {
                    this.setState({ confirmOpen: true })
                  }
                : this.fireButtonAction
            }
          >
            {this.props.label}
          </button>
        ) : null}
        {this.props.type === 'button' && this.props.requiresConfirm ? (
          <Portal isOpened={this.state.confirmOpen}>
            <ConfirmDialog
              closeModal={() => {
                this.setState({ confirmOpen: false })
              }}
              onModalClosed={() => {
                if (this.state.confirmed) {
                  this.fireButtonAction()
                }
              }}
              message={this.props.confirmMessage}
              buttons={[
                { label: 'No', onClick: noop, className: 'btn-default' },
                {
                  label: 'Yes',
                  onClick: () => {
                    this.setState({ confirmed: true })
                  },
                  className: 'btn-danger'
                }
              ]}
              modalStyle={{ borderRadius: 3 }}
            />
          </Portal>
        ) : null}
        {this.props.type === 'textEditor' ? (
          <TextEditor
            buttonLabel={this.props.label}
            name={this.props.name}
            onSave={this.handleGenericChange}
            text={this.props.text}
            placeholder={this.props.placeholder}
            allowMergeCodes={this.props.allowMergeCodes}
          />
        ) : null}
        {this.props.type === 'metaEditor' ? (
          <MetaEditor
            pairs={this.props.value}
            name={this.props.name}
            id={this.props.id}
            onChange={this.handleGenericChange}
            buttonLabel={this.props.buttonLabel}
          />
        ) : null}
        {this.props.type === 'fieldSrc' && (
          <FieldSrcSelect {...this.props} onChange={this.handleGenericChange} />
        )}
        {this.props.type === 'srcRepeaterColumn' && (
          <FieldSrcSelect
            {...this.props}
            onChange={this.handleGenericChange}
            limitToRepeaterSiblings
          />
        )}
        {this.props.type === 'constraints' && (
          <ConstraintsEditor
            {...this.props}
            onChange={value => {
              this.handleGenericChange(this.props.name, value)
            }}
          />
        )}
        {this.props.type === 'selectOptionConstrainer' && (
          <SelectOptionConstrainer
            {...this.props}
            onChange={value => this.handleGenericChange(this.props.name, value)}
          />
        )}
        {this.props.type === 'localComplete' && (
          <FieldSrcSelect
            {...this.props}
            onChange={this.handleGenericChange}
            type="MultiComplete"
          />
        )}
        {this.props.type === 'customBusinessRules' && (
          <CustomBusinessRulesEditor
            {...this.props}
            onChange={this.handleGenericChange}
          />
        )}
        {this.props.type === 'regulatedWords' && (
          <RegulatedWordsSelector {...this.props} onChange={list => this.handleGenericChange(this.props.name, list)} id={this.id} />
        )}
        {this.props.children}
      </div>
    )
  }
}
Attribute = connect((state, props) => {
  const selected = state.designer.selected
  if(selected){
    switch (selected.type){
      case 'FIELD': {
        const isLogicControlled = getIsLogicControlled(
          selected.id,
          props.name,
          state.designer.wizard.fields
        )
        return { isLogicControlled }
      }
      case 'WIZARD': {
        const isLogicControlled = getWizardAttributeIsLogicControlled(state.designer.wizard.wizardAttributesLogic, props.name)
        return { isLogicControlled }
      }
      default: return { isLogicControlled: false }
    }
  }else{
    return { isLogicControlled: false }
  }
})(Attribute)

class RequiredAttribute extends Component {
  handleChange = (name, value) => {
    this.props.onChange(name, value)
  }
  render() {
    return (
      <div className="block-wrapper" style={{ marginTop: -10 }}>
        <Attribute
          padding={false}
          label="Show Required Indicator"
          type="checkbox"
          name="required"
          value={this.props.checked}
          handleChange={this.handleChange}
        ></Attribute>
        {!this.props.hasBusinessRules && this.props.checked ? (
          <AttributeWarning>
            You've added a required indicator without adding any business rules. This will render a
            field which appears to be required, but will not be validated. To fix this, click{' '}
            <b>"Edit Business Rules"</b> to add rules.
          </AttributeWarning>
        ) : null}
      </div>
    )
  }
}

class ServerAttributeSelect extends Component {
  constructor() {
    super()
    this.state = {
      optionsSources: [{ value: 'loading', label: 'Loading' }],
      subOptionsSources: [{ value: 'loading', label: 'Loading' }],
      optionsSourcesLoaded: false,
      initialLoad: true,
      options: []
    }
  }
  componentDidMount = () => {
    this.getItems()
  }
  componentDidUpdate = (prevProps, prevState) => {
    if (this.props.controlType !== prevProps.controlType) {
      this.getItems()
    }
  }
  getItems = () => {
    this.getLookupGroups()
    if (this.props.optionsSrc !== '0') {
      if (this.props.subOptionsSrc !== '') {
        GET_GROUP_ITEMS(this.props.optionsSrc, subOptionsSources => {
          this.setState({
            subOptionsSources: Array.isArray(subOptionsSources)
              ? subOptionsSources
              : subOptionsSources.options
          })
        })
        this.getGroupItems(this.props.optionsSrc + '/' + this.props.subOptionsSrc)
      } else {
        this.getGroupItems(this.props.optionsSrc)
      }
    }
  }
  getLookupGroups = () => {
    GET_LOOKUP_GROUPS(this.props.controlType, groups => {
      let options = groups.map(group => ({ ...group, label: this.formatLabel(group.label) }))
      this.setState({ optionsSources: options, optionsSourcesLoaded: true })
    })
  }
  getSubLookupGroups = () => {
    GET_LOOKUP_GROUPS(this.props.optionsSrc, groups => {
      //console.log(groups);
    })
  }
  getGroupItems = groupId => {
    if (!this.state.initialLoad) {
      this.props.onChange('selectedIndex', 0)
      this.props.onChange('value', '0')
    }
    GET_GROUP_ITEMS(groupId, items => {
      const options = Array.isArray(items) ? items : items.options;
      this.props.setOptionsCacheById(groupId + (groupId.endsWith("/") ? "" : "/"), options)
      this.setState({ initialLoad: false, options })
    })
  }
  formatLabel = str => {
    str = str.toLowerCase().split(' ')
    for (var i = 0; i < str.length; i++) {
      str[i] = str[i].split('')
      if (str[i].length > 0) {
        str[i][0] = str[i][0].toUpperCase()
        str[i] = str[i].join('')
      }
    }
    return str
      .join(' ')
      .replace('_', ' ')
      .replace('-', ' ')
  }
  handleSourceChange = (name, value) => {
    this.props.onChange(name, value)
    const selectedOptionSrc = this.state.optionsSources.find(option => option.value == value)
    const hasSubGroupsYN = selectedOptionSrc ? selectedOptionSrc.hasSubGroupsYN : false
    if (!hasSubGroupsYN) {
      this.props.onChange('options', [{ value: 'loading', label: 'Loading' }])
      this.getGroupItems(value)
    } else {
      this.props.onChange('selectedIndex', 0)
      this.props.onChange('options', [{ value: 'default', label: 'None' }])
      GET_GROUP_ITEMS(value, subOptionsSources => {
        //console.log(subOptionsSources)
        this.setState({ subOptionsSources: subOptionsSources.options })
      })
    }
  }
  handleSubSourceChange = (name, value) => {
    this.props.onChange('subOptionsSrc', value)
    this.getGroupItems(this.props.optionsSrc + '/' + value)
  }
  handleValueChange = (name, value) => {
    this.props.onChange(name, value)
    let selectedIndex = this.props.options.findIndex(option => {
      return value == option.value
    })
    if (selectedIndex < 0) {
      selectedIndex = 0
    }
    this.props.onChange('selectedIndex', selectedIndex)
  }
  render() {
    const {
      optionsSrc,
      hideDefaultValue,
      isOverridingOptionsSrc,
      isOverridingSubOptionsSrc,
      isInRepeater
    } = this.props
    const selectedOptionSrc = this.state.optionsSources.find(option => option.value == optionsSrc)
    const hasSubGroupsYN = selectedOptionSrc ? selectedOptionSrc.hasSubGroupsYN : false
    return (
      <div className="block-wrapper">
        {!isOverridingOptionsSrc && (
          <Attribute
            padding={false}
            label="Options Source"
            type="select"
            name="optionsSrc"
            value={this.props.optionsSrc}
            handleChange={this.handleSourceChange}
            options={[{ value: '0', label: '[Select a source]' }, ...this.state.optionsSources]}
          />
        )}
        {hasSubGroupsYN && !isOverridingSubOptionsSrc ? (
          <Attribute
            padding={false}
            label="Sub-options Source"
            type="select"
            name="subOptionsSrc"
            value={this.props.subOptionsSrc}
            handleChange={this.handleSubSourceChange}
            options={[
              { value: '0', label: '[Select a sub-option source]' },
              ...this.state.subOptionsSources
            ]}
          />
        ) : null}
        {!isOverridingSubOptionsSrc ? (
          this.props.required ? (
            <Attribute
              padding={false}
              label="Default Value"
              type="select"
              name={isInRepeater ? 'defaultValue' : 'value'}
              value={isInRepeater ? this.props.defaultValue : this.props.value}
              handleChange={this.handleValueChange}
              options={[{ value: '0', label: '[Select an Option]' }, ...this.state.options]}
            />
          ) : !hideDefaultValue ? (
            <div className="block-wrapper">
              <Attribute
                padding={false}
                label="Default Value"
                type="select"
                name={isInRepeater ? 'defaultValue' : 'value'}
                value={isInRepeater ? this.props.defaultValue : this.props.value}
                handleChange={this.handleValueChange}
                options={[{ value: '0', label: this.props.placeholder }, ...this.state.options]}
              />
              {this.props.value !== '0' ? (
                <AttributeWarning>
                  Choosing a default option other than the empty option, "{this.props.placeholder}"
                  will exclude "{this.props.placeholder}" from the available options.
                </AttributeWarning>
              ) : null}
              <Attribute
                padding={false}
                label="Empty Option"
                type="text"
                name="placeholder"
                value={this.props.placeholder}
                handleChange={this.props.onChange}
                tip='This option defaults to "None", but can be edited below. If the user selects this option it will be ignored by the server when submitting the form.'
              />
            </div>
          ) : null
        ) : null}
      </div>
    )
  }
}
ServerAttributeSelect = connect(
  null,
  {setOptionsCache, setOptionsCacheById}
)(ServerAttributeSelect)

class FieldSrcSelect extends Component {
  handleChange = e => {
    this.props.onChange(this.props.name, e.target.value)
  }
  render() {
    const {
      options,
      emptyOptionLabel = '[Select an Option]',
      value,
      emptyOptionValue = '',
      type,
      selectedOptionExists
    } = this.props
    return type === 'MultiComplete' ? (
      <MultiComplete
        onChange={v => this.props.onChange(this.props.name, v)}
        options={options}
        value={value}
      />
    ) : (
      <select onChange={this.handleChange} value={value}>
        {!selectedOptionExists ? (
          <option value={value}>[Selected Field Is Not Valid]</option>
        ) : null}
        <option value={emptyOptionValue}>{emptyOptionLabel}</option>
        {options.map((option, i) => {
          return (
            <option value={option.value} key={i}>
              {option.label}
            </option>
          )
        })}
      </select>
    )
  }
}
FieldSrcSelect = connect((state, props) => {
  const {
    props: { excludeSelf, allowedTypes = [] } = {},
    parentField = {},
    excludeSelf: secondExcludeSelf,
    parentFieldId
  } = props
  let options = Object.keys(state.designer.wizard.fields).map(fieldId => {
    const label = state.designer.wizard.fields[fieldId].label
    const name = state.designer.wizard.fields[fieldId].name
    return {
      value: fieldId,
      label:
        label !== '' && label ? (label.length > 50 ? label.substring(0, 50) + '...' : label) : name
    }
  })
  if (props.limitToRepeaterSiblings) {
    const parent = state.designer.wizard.fields[props.parentField.parent.id]
    options = options.filter(opt => parent.template.includes(opt.value))
  }
  if (excludeSelf || secondExcludeSelf) {
    options = options.filter(opt => opt.value !== (parentFieldId || parentField.fieldId))
  }
  if (allowedTypes.length) {
    options = options.filter(opt => {
      const type = state.designer.wizard.fields[opt.value].type
      return allowedTypes.includes(type)
    })
  }
  return {
    options,
    selectedOptionExists: props.value ? !!options.find(opt => opt.value === props.value) : true
  }
})(FieldSrcSelect)

class GenericServerAttributeSelect extends Component {
  constructor() {
    super()
    this.state = { options: null }
  }
  componentDidMount() {
    if (this.props.getOptionsFunction) {
      this.props.getOptionsFunction(options => {
        this.setState({ options })
      })
    } else {
      this.setState({ options: [] })
    }
  }
  render() {
    const { value, name, staticOptions = [] } = this.props
    return (
      <Attribute
        padding={false}
        label=""
        type="select"
        disabled={this.state.options === null}
        name={name}
        value={value}
        handleChange={this.props.onChange}
        options={
          this.state.options
            ? [...staticOptions, ...this.state.options]
            : [{ value: '0', label: 'Loading...' }]
        }
      />
    )
  }
}

export const AttributeWarning = ({ children }) => (
  <div className="block-wrapper attribute-warning">
    <span className="glyphicon glyphicon-warning-sign"></span> <b>Warning:</b> {children}
  </div>
)

export const getIsLogicControlled = (fieldId, name, fields) => {
  const field = fields[fieldId]

  if (field) {
    const outputNode = Object.values(field.logicNodes).find(n => n.type === 'output')
    if (outputNode) {
      const logicControlMap = Object.keys(outputNode.connections.inputs).reduce((obj, input) => {
        obj[input] = true
        return obj
      }, {})[name]
      return logicControlMap
    } else {
      return false
    }
  } else {
    return false
  }
}

export const getWizardAttributeIsLogicControlled = (logic, name) => {
  const outputNode = Object.values(logic.nodes).find(n => n.root)
  if (outputNode) {
    const logicControlMap = Object.keys(outputNode.connections.inputs).reduce((obj, input) => {
      obj[input] = true
      return obj
    }, {})[name]
    return logicControlMap
  } else {
    return false
  }
}



// WEBPACK FOOTER //
// ./src/components/Designer2/Attribute.js